import React, { useContext, useState, useEffect } from 'react'
import GlobalContext from '../../../contexts/GlobalContext';
import { Form, Button, Message, Header } from 'semantic-ui-react';
import MomentCustomer from '../../MomentCustomer/MomentCustomer';
import Moment from 'moment';
import API from '../../../API';
import Utility from '../../../Utility';
import { toast } from 'react-toastify';
import InputText from '../../FormInputCustomer/InputText/InputText';
import { SET_USER_ACTIONS } from '../../../contexts/GlobalType';
import ModalTransition from '../../ModalTransition/ModalTransition';
import './FormDeleteAccount.css';

const FormDeleteAccount = (props) => {
  const [globalContext, dispatch] = useContext(GlobalContext);
  const [actionDeleteAccountState, setActionDeleteAccountStateState] = useState({});
  const [modalOpenState, setModalOpenState] = useState(false);
  const [errorState, setErrorState] = useState(false);

  const initListError = () => {
    let listInput = getListInput();
    let error = {};

    for (let index in listInput) {// eslint-disable-line no-unused-vars
      let input = listInput[index];
      error[input.name] = false;
    }
    return error;
  }

  useEffect(() => {
    let actionDeleteAccount = {};
    if (Array.isArray(globalContext.userActionTypes) && Array.isArray(globalContext.userActions) && globalContext.userActions.length > 0) {
      const userActionTypes = {};

      for (let modelAction of globalContext.userActionTypes) {// eslint-disable-line no-unused-vars
        userActionTypes[modelAction.code] = modelAction;
      }

      for (let action of globalContext.userActions) {// eslint-disable-line no-unused-vars
        if (userActionTypes['SEND_MAIL_DELETE_ACCOUNT'].id === action.customerFileActionType) {
          actionDeleteAccount = {
            date: action.date,
          }
        }
      }
    }

    setActionDeleteAccountStateState(actionDeleteAccount);
  }, [globalContext.userActionTypes, globalContext.userActions]);

  const getButtonDeleteCompte = () => {
    let message = null;
    let status = {
      disabled: false,
      negative: true,
      positive: false,
    };

    if (actionDeleteAccountState.date) {
      let dateNow = Moment(),
        dateAddOneMonth = Moment(actionDeleteAccountState.date).add(30, 'days');
      if (dateNow <= dateAddOneMonth) {
        status.negative = false;
        status.positive = true;
        status.disabled = true;
      }

      message = (
        <Message
          success
          visible
          header={[globalContext.translations.dateLastRequestDeleteAccount, ' : ', <MomentCustomer>{actionDeleteAccountState.date}</MomentCustomer>]}
        />
      );
    }

    return (
      <div>
        {message}
        <Button
          icon={(status.positive) ? 'checkmark' : 'delete'}
          id="btn-delete-account"
          labelPosition="left"
          negative={status.negative}
          positive={status.positive}
          content={globalContext.translations.deleteMyAccount}
          disabled={status.disabled}
          onClick={handleOpenModal}
        />
      </div>
    )
  }

  const handleOpenModal = () => {
    setModalOpenState(true);
  }

  const handleCloseModal = () => {
    document.body.classList.remove('modal-fade-in');
    setModalOpenState(false);
  }

  const handleClickSendDeleteAccount = async (event) => {
    const listInput = getListInput();
    const listError = initListError();
    let dataForm = new FormData(event.target.closest('.modal').querySelector('form')),
      error = false;

    const listInputCheckValue = {
      [listInput.password.name]: Utility.checkValue(listInput.password.name, dataForm.get('input_password'), listInput.password.typePattern),
    }

    if (listInputCheckValue[listInput.password.name].error === true) {
      error = true;
      listError[listInput.password.name] = true;
    }

    if (error === false) {
      dataForm.append('password', dataForm.get('input_password'));
      dataForm.delete('input_password');
      dataForm = new URLSearchParams(dataForm);
      API.postForm(Utility.getUrlAjax() + '/removeUserInformationsAction', dataForm)
        .then(res => {
          if (res.status === 200) {
            if (res.data.success === true) {
              dispatch({ type: SET_USER_ACTIONS, payload: res.data.data.userActions });
              if (res.data.message) {
                toast.success(res.data.message);
              }
            } else {
              toast.error(res.data.message);
            }
          } else {
            toast.error(res.data.message);
          }
        })
        .catch(err => {
          console.error(err)
          toast.error(globalContext.translations.msgErreurInconnu);
        })
      handleCloseModal();
    } else {
      setErrorState(listError);

    }
  }

  const getListInput = () => {
    return {
      password: {
        name: 'password',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
      },
    }
  }

  const getModalConfirm = () => {
    let listInput = getListInput();

    return (
      <ModalTransition
        size="tiny"
        open={modalOpenState}
        handleClose={handleCloseModal}
        header={globalContext.translations.deleteAccount}
        content={
          <Form>
            {globalContext.translations.msgDeleteAccountConfirm}
            <br />
            <br />
            <Form.Group widths="equal">
              <InputText
                type="password"
                label={globalContext.translations.password}
                name={listInput.password.name}
                required={listInput.password.required}
                typePattern={listInput.password.typePattern}
                error={errorState.password}
                labelError={globalContext.translations.passwordRequired}
              />
            </Form.Group>
          </Form>
        }
        actions={
          <div>
            <Button
              color="grey"
              icon="cancel"
              labelPosition="right"
              content={globalContext.translations.preCheckInCancel}
              onClick={handleCloseModal} />
            <Button
              negative
              icon="checkmark"
              labelPosition="right"
              content={globalContext.translations.validate}
              onClick={handleClickSendDeleteAccount} />
          </div>
        }
      />
    )
  }

  return (
    <div>
      <Form>
        <Form.Group widths="equal">
          <Form.Field>
            <Header as="h4">{globalContext.translations.speechDeleteCompte}</Header>
            {getButtonDeleteCompte()}
          </Form.Field>
        </Form.Group>
        <Message
          error
          visible
          header={globalContext.translations.whenDeleteAccount}
          list={[
            globalContext.translations.whenDeleteAccountRes1,
            globalContext.translations.whenDeleteAccountRes2,
          ]}
        />
      </Form>

      {getModalConfirm()}
    </div>
  )
}

export default FormDeleteAccount;